import { render, staticRenderFns } from "./TaArea.vue?vue&type=template&id=0a7f59aa&scoped=true&"
import script from "./TaArea.vue?vue&type=script&lang=js&"
export * from "./TaArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f59aa",
  null
  
)

export default component.exports